module.exports = __webpack_public_path__ + "img/jd.4083bf1c.png";